import {KeyService} from "@/services/KeyService";
import {EmailService} from "@/services/EmailService";

const state = {
  emailKeys : [],
  emailLists : [],
  viewedEmail : null
}

const mutations = {
  setEmailKeys: (state, emailKeys) => state.emailKeys = emailKeys,
  setEmailLists: (state, emailLists) => state.emailLists = emailLists,
  setViewedEmail : (state, viewedEmail) => state.viewedEmail = viewedEmail
}

const actions = {
  async getEmailKeys({commit}) {
    const emailKeys = await EmailService.getEmailKeys()
    if (emailKeys) commit('setEmailKeys', emailKeys)
  },
  async getEmailLists({commit}, params) {
    const emailLists = await EmailService.getEmailLists(params)
    if (emailLists) {
      commit('setEmailLists', emailLists?.data)
      commit('setPagination', emailLists, { root: true })
    }
  },
  async addEmail({commit, dispatch}, params) {
    return await EmailService.addEmail(params)
  },
  async deleteEmailById({commit}, params) {
    return await EmailService.deleteEmailById(params);
  },
  async updateEmailById({commit}, params) {
    return await EmailService.updateEmailById(params);
  },
  async getEmailById({commit}, emailId) {
    const emailDetails = await EmailService.getEmailById(emailId);
    if (emailDetails) {
      commit('setViewedEmail', emailDetails);
    }
  },
  async updateEmailModuleFeature({commit}, params) {
    return await EmailService.updateEmailModuleFeature(params);
  }
}

const getters = {
  emailKeys : state => state.emailKeys,
  emailLists : state => state.emailLists,
  viewedEmail : state => state.viewedEmail,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
